import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { Fragment } from 'react/jsx-runtime'

import { getCenter } from '../../../../api/centers/get-center'
import { getTeachingHalls } from '../../../../api/ols/teaching-halls/get-teaching-halls'
import { useDataProps } from '../../../../lib/hooks/use-data-props'
import { useNativeCountryName } from '../../../../lib/hooks/use-native-country-name'
import { AccomodationEnum } from '../../../../lib/types/enums/accomodation-type/accomodation-type'
import { Center } from '../../../../lib/types/models/center/center'
import { DataProps } from '../../../../lib/types/utils'
import LoadingScreen from '../../../elements/loading/loading-screen'
import LabelWithText from '../../ols/label-with-text'
import { CenterAddressCoursesLabel } from '../shared/center-address-courses'

const CenterCourseLocation = (props: DataProps<Center>) => {
  const nativeCountryName = useNativeCountryName()
  const { data: center } = useDataProps(props, (id) => getCenter(id, 'FULL'))

  const { data: teachingHalls } = useQuery({
    queryKey: ['centers', center?.id, center?.olId],
    queryFn: () => {
      if (center?.olId) return getTeachingHalls(center.olId, { filter: { centerId: center.id } })
      return null
    },
    enabled: !!center && center.accomodation === AccomodationEnum.HOST_FAMILY
  })

  if (!center) return <LoadingScreen />

  return (
    <InnerBox className="bg-white-hover rounded-lg">
      <Typography variant="tag" color={tailwindColors.primary.DEFAULT}>
        Détails
      </Typography>

      <div className="h-2" />

      <div className="grid grid-cols-4 gap-3">
        {AccomodationEnum.HOST_FAMILY === center.accomodation ? (
          teachingHalls?.data.map((teachingHall) => (
            <Fragment key={teachingHall.id}>
              <LabelWithText label="Nom du centre de cours" data={teachingHall.name} />
              <LabelWithText
                label="Adresse"
                data={`${teachingHall.address1}, ${nativeCountryName(teachingHall.country)}`}
              />
              <LabelWithText label="Code postal" data={teachingHall.postalCode} />
              <LabelWithText label="Ville" data={teachingHall.city} />
            </Fragment>
          ))
        ) : (
          <CenterAddressCoursesLabel data={center} />
        )}
      </div>
    </InnerBox>
  )
}

export default CenterCourseLocation
